<template>
  <div class="page">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        :style="{ backgroundImage: `url(${this.seasonBanners[episode.season - 1]})` }"
      >
      </parallax>
      <div class="content-center">
        <p class="title">{{ episode.title }}</p>
        <audio controls metadata preload="none" class="mt-5" :key="audioPlayerkey">
          <source :src="episode.mediaURL" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
        <div>
          Or listen on:
        </div>
        <div>
          <a class="listenApple" :href="episode.appleURL" rel="tooltip" title="Apple iTunes" data-placement="bottom">
            <i class="fab fa-itunes" style="font-size:24px"></i
          ></a>
          <a
            class="listenSpotify"
            href="https://open.spotify.com/show/5a5WyCi7f1xFs0S4ZE4rNo"
            rel="tooltip"
            title="Spotify"
            data-placement="bottom"
          >
            <i class="fab fa-spotify" style="font-size:24px"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="container mt-4 mb-4">
      <div class="row">
        <card class="col-md-6 m-auto">
          <tabs type="primary">
            <tab-pane label="In this Episode...">
              <p v-html="episode.description"></p>
              <br />

              <span v-if="episode.id === 'S3E4'">
                <p>
                  Download a transcript of this episode
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/endoftheworldblog-ded1e.appspot.com/o/Episodes%2FSeason%203%2FEpisode%204%20transcript.docx.pdf?alt=media&token=14eb0a58-5b70-490d-9e3d-85ca7c86a548"
                    target="_blank"
                    ><b>here.</b></a
                  >
                </p></span
              >
            </tab-pane>
            <tab-pane label="Artists" class="row">
              <div v-for="(artist, index) in episode.artists" :key="index">
                <div>
                  <router-link :to="{ path: '/artist/' + artist.Aid }">
                    <h5>{{ artist.givenName }} {{ artist.lastName }}</h5>
                  </router-link>
                </div>

                <div>
                  <p v-html="artist.bio">
                    <br />
                    <a :href="artist.website"
                      ><small><i>More info</i></small></a
                    >
                  </p>
                </div>
              </div>
            </tab-pane>
            <tab-pane label="Credits">
              <p>
                This project is the brainchild of poet, writer and journalist
                <strong><a href="http://www.twitter.com/eleanorkpenny">Eleanor Penny</a></strong
                >.<br /><br />
                Project Producer <strong><a href="http://tommacandrew.com/">Tom MacAndrew</a></strong
                >.<br /><br />
                Series {{ episode.season }} produced & edited by
                <strong
                  ><a :href="this.$store.state.episodesStore[episode.season - 1].producerSite">{{
                    this.$store.state.episodesStore[episode.season - 1].producer
                  }}</a></strong
                ><br /><br />
                <span v-if="episode.id === 'S2E2'"> Additional recording by Daniel Winshall.</span>
              </p>
            </tab-pane>
          </tabs>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from '@/components';
import { Tabs, TabPane } from '@/components';
import { Parallax } from '@/components';

export default {
  name: 'episode',
  components: {
    Card,
    Tabs,
    TabPane,
  },
  data() {
    return {
      audioPlayerkey: 0,
      bannerLoaded: false,
      seasonBanners: this.$store.state.episodesStore.map((season) => {
        return season.seasonBannerImg;
      }),
    };
  },
  computed: {
    episode() {
      return this.$store.getters.loadedEpisode(this.$route.params.id);
    },
    computedMediaURL() {
      return this.episode.mediaURL;
    },
  },
  watch: {
    computedMediaURL() {
      return (this.audioPlayerkey += 1);
    },
  },
};
</script>
<style>
.page {
  min-height: calc(100vh - 95px);
}
.title {
  font-size: 3rem;
}
.fab {
  margin: 5px;
}
.listenApple {
  color: white;
}
.listenApple:visited {
  color: rgb(255, 255, 255);
}
.listenApple:hover {
  color: rgb(255, 255, 255);
}
.listenSpotify {
  color: white;
}
.listenSpotify:visited {
  color: rgb(255, 255, 255);
}
.listenSpotify:hover {
  color: rgb(255, 255, 255);
}
</style>
